export enum BAR_MODIFIER_TYPE {
  FLAT = 'FLAT',
  RATE = 'RATE',
}
export type BarModifierType =
  (typeof BAR_MODIFIER_TYPE)[keyof typeof BAR_MODIFIER_TYPE];
